import type { Entities } from './types';

export function convertBio(bio: string, entities: Entities) {
    if (!bio) return bio;

    let processedBio = bio;

    // Handle URLs from entities.description
    if (entities.description?.urls) {
        // Sort URLs by their start index in reverse order to avoid index shifting
        const sortedUrls = [...entities.description.urls].sort(
            (a, b) => b.indices[0] - a.indices[0],
        );

        for (const url of sortedUrls) {
            const [start, end] = url.indices;
            const displayText = url.display_url;
            const expandedUrl = url.url;

            // Replace the URL in the bio with an anchor tag
            processedBio =
                processedBio.slice(0, start) +
                `<a href="${expandedUrl}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${displayText}</a>` +
                processedBio.slice(end);
        }
    }

    // Convert @mentions to x.com handle URLs
    processedBio = processedBio.replace(
        /@(\w+)/g,
        '<a href="https://x.com/$1" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">@$1</a>',
    );

    return processedBio;
}

export const categories = [
    'Portfolio',
    'AI',
    'Web3',
    'agency',
    'Design',
    'Startup',
    'E-commerce',
    'Mobile apps',
    'Desktop apps',
    'Development',
    'Tech',
    'Finance',
];
